import { render, staticRenderFns } from "./channelTabs.vue?vue&type=template&id=717f8beb"
import script from "./channelTabs.vue?vue&type=script&lang=js"
export * from "./channelTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports